import { isConfigurationAttributeBool, isConfigurationAttributeNumeric, isConfigurationAttributeString, } from "./isConfigurationAttribute";
export function isConfigurationValueNumeric(attribute, value) {
    return (isConfigurationAttributeNumeric(attribute) &&
        typeof value.value === "number");
}
export function isConfigurationValueBool(attribute, value) {
    return (isConfigurationAttributeBool(attribute) && typeof value.value === "boolean");
}
export function isConfigurationValueString(attribute, value) {
    return (isConfigurationAttributeString(attribute) && typeof value.value === "string");
}
//# sourceMappingURL=isConfigurationValue.js.map